import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { RulesPage } from './pages/RulesPage';
import { initializePostHog } from './utilities/analytics';
import { SpeedInsights } from '@vercel/speed-insights/react';

export function App() {
  useEffect(() => {
    initializePostHog();
  }, []);

  return (
    <BrowserRouter>
      <SpeedInsights />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/rules" element={<RulesPage />} />
      </Routes>
    </BrowserRouter>
  );
}
